module.exports = __webpack_public_path__ + "static/media/faq_(17).2b8aa67b.gif";